import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import PASSection from "@/components/PASSection";
import FeaturesSection from "@/components/FeaturesSection";
import BookSection from "@/components/BookSection";
import PricingSection from "@/components/PricingSection";
import InquirySection from "@/components/InquirySection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <main className="min-h-screen bg-background overflow-hidden">
      <Navbar />
      <section id="hero"><HeroSection /></section>
      <section id="about"><PASSection /></section>
      <section id="features"><FeaturesSection /></section>
      <PricingSection />
      <section id="book"><BookSection /></section>
      <section id="inquiry"><InquirySection /></section>
      <section id="cta"><CTASection /></section>
      <Footer />
    </main>
  );
};

export default Index;
